import { cn } from "@dalmatech/ui"

const root = cn("relative w-[92px]")
const trigger = cn("flex max-h-10 items-center justify-center gap-3 p-4")
const content = cn("mt-1.5 flex w-[92px] gap-1 rounded-xl border-2 border-neutral-200 bg-white p-2")
const item = cn(
  "flex justify-center rounded-[0.25rem] py-2.5 hover:cursor-pointer hover:bg-blurple-200"
)

export { root, trigger, content, item }
